/* Klinetix — carrusel horizontal liviano con autoplay en loop.
   Funciona sobre un scroll nativo (drag/swipe gratis en mobile y desktop);
   el loop se logra clonando las slides una vez, avanzando por índice lógico
   con scrollTo() absoluto, y — solo una vez la animación smooth terminó de
   asentarse — saltando sin animación de vuelta al bloque original si el
   índice cayó dentro del bloque clonado (el salto es invisible porque el
   contenido clonado es idéntico al original).

   Nota: la versión anterior mezclaba un scrollLeft instantáneo con un
   scrollBy() animado en el mismo tick del intervalo. En mobile (donde el
   scroll-snap + smooth scroll ya es más lento/impreciso) eso hacía que el
   siguiente ciclo del autoplay pudiera disparar antes de que la animación
   previa terminara de asentarse, produciendo pequeños saltos que se
   acumulaban ciclo a ciclo hasta que el scroll quedaba fuera de rango
   (contenido en blanco) — solo se recuperaba al interactuar porque eso
   cancelaba el scroll en curso. Este archivo evita esa condición de carrera
   con una bandera "animating" que ignora cualquier paso nuevo hasta que el
   anterior terminó de asentarse. */
(function () {
  function gapOf(track) {
    var style = getComputedStyle(track);
    return parseFloat(style.columnGap || style.gap || '0') || 0;
  }

  function slideWidth(track) {
    var first = track.children[0];
    return first ? first.getBoundingClientRect().width + gapOf(track) : 0;
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-klinetix-track]');
    if (!track || track.dataset.klinetixInit === 'true') return;
    track.dataset.klinetixInit = 'true';

    var originalCount = track.children.length;
    if (originalCount === 0) return;

    var originals = Array.prototype.slice.call(track.children);
    originals.forEach(function (slide) {
      var clone = slide.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a, button, input, [tabindex]').forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });
      track.appendChild(clone);
    });

    // índice lógico de la slide mostrada; puede superar originalCount
    // mientras recorre el bloque clonado, y se reinicia sin animación una
    // vez que el usuario ya no puede notarlo.
    var index = 0;
    var prevBtn = root.querySelector('[data-klinetix-prev]');
    var nextBtn = root.querySelector('[data-klinetix-next]');
    var interval = parseInt(root.getAttribute('data-autoplay-interval'), 10) || 3500;
    var timer = null;
    var settleTimer = null;
    var animating = false;

    function goTo(i, smooth) {
      var sw = slideWidth(track);
      if (!sw) return;
      track.scrollTo({ left: sw * i, behavior: smooth ? 'smooth' : 'auto' });
    }

    function step(direction) {
      if (animating) return;
      animating = true;
      index += direction;
      goTo(index, true);
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(function () {
        animating = false;
        if (index >= originalCount) {
          index -= originalCount;
          goTo(index, false);
        } else if (index < 0) {
          index += originalCount;
          goTo(index, false);
        }
      }, 500);
    }

    function play() {
      stop();
      timer = setInterval(function () {
        step(1);
      }, interval);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        step(-1);
        play();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        step(1);
        play();
      });
    }

    ['mouseenter', 'touchstart', 'focusin'].forEach(function (evt) {
      root.addEventListener(evt, stop, { passive: true });
    });
    ['mouseleave', 'touchend', 'focusout'].forEach(function (evt) {
      root.addEventListener(evt, play, { passive: true });
    });

    play();
  }

  function initAll() {
    document.querySelectorAll('[data-klinetix-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector && event.target.querySelector('[data-klinetix-carousel]');
    if (root) initCarousel(root);
  });
})();
